module.exports = __webpack_public_path__ + "img/153.727389d9.png";